import { Session, StockSymbol } from '@benzinga/session';
import { Subscribable } from '@benzinga/subscribable';
import { QuoteHoldingsFeed, QuoteHoldingsFeedEvent } from './feed';

export type QuotesV3HoldingsManagerEvent = QuoteHoldingsFeedEvent;

export class QuotesV3HoldingsManager extends Subscribable<QuotesV3HoldingsManagerEvent> {
  private session: Session;

  constructor(session: Session) {
    super();
    this.session = session;
  }

  public static getName = () => 'benzinga-quote-v3-holdings';
  public static getEnvironment = (_env: Record<string, string>) => ({});

  public createQuotesFeed = (symbols: StockSymbol[], subscribeToQuotes: boolean): QuoteHoldingsFeed => {
    return new QuoteHoldingsFeed(symbols, subscribeToQuotes, this.session);
  };
}
